module.exports = __webpack_public_path__ + "static/media/step2@2x.6dbb57c7.mov";